"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Snackbar = require("./Snackbar.styles");

var _Icon = _interopRequireDefault(require("./Icon"));

var _iconClose = _interopRequireDefault(require("../../assets/images/iconClose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shared = require("../../shared");

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Snackbar = ({
  kind,
  children,
  dismissable,
  label,
  onDismiss,
  show,
  withIcon,
  className,
  height,
  width,
  backgroundColor,
  textColor = '#121213',
  isFloating = false,
  isHighEmphasis = false,
  position = 'top-center',
  enablePortal,
  zIndex,
  ...others
}) => {
  const [alertVisible, setVisible] = (0, _react.useState)(false);
  const [slideIn, setSlideIn] = (0, _react.useState)(false);
  const [fadeOut, setFadeOut] = (0, _react.useState)(false);
  const bgColor = {
    success: _shared.theme.palette.brand.primary.charcoal,
    alert: _shared.theme.palette.ui.cta.red,
    notification: '#ffffff',
    message: _shared.theme.palette.brand.primary.charcoal
  };
  (0, _react.useEffect)(() => {
    if (show) {
      setTimeout(() => setSlideIn(true), 500);
    }
  }, [show]);

  const handleAlertDismiss = () => {
    if (typeof onDismiss == 'function') onDismiss();
    setFadeOut(true);
    setTimeout(() => {
      setVisible(false);
      setSlideIn(false);
      setFadeOut(false);
    }, 300);
  };

  const visible = typeof show === 'undefined' ? alertVisible : show;
  if (!visible) return /*#__PURE__*/_react.default.createElement("span", null);
  let iconColumn;

  if (withIcon) {
    iconColumn = /*#__PURE__*/_react.default.createElement("div", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      kind: kind
    }));
  }

  let dismissableColumn;

  if (dismissable) {
    dismissableColumn = /*#__PURE__*/_react.default.createElement("div", {
      className: "dismiss",
      "data-testid": "sb-dismiss",
      onClick: handleAlertDismiss
    }, /*#__PURE__*/_react.default.createElement(_iconClose.default, null));
  }

  const getSnackbarBody = () => {
    return /*#__PURE__*/_react.default.createElement(_Snackbar.StyledSnackbar, _extends({
      className: (0, _classnames.default)({
        [kind]: kind,
        [className]: className,
        animate: slideIn,
        fadeout: fadeOut,
        [position]: position
      })
    }, others, {
      height: height,
      width: width,
      show: show,
      isFloating: isFloating,
      textColor: textColor,
      isHighEmphasis: isHighEmphasis,
      backgroundColor: backgroundColor ? backgroundColor : bgColor[kind],
      position: position,
      zIndex: zIndex
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, iconColumn, /*#__PURE__*/_react.default.createElement("div", {
      className: "col col-middle"
    }, /*#__PURE__*/_react.default.createElement("div", null, label && /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, label), children)), dismissableColumn));
  };

  return enablePortal ? /*#__PURE__*/_reactDom.default.createPortal(getSnackbarBody(), document.body) : getSnackbarBody();
};

exports.Snackbar = Snackbar;
Snackbar.propTypes = {
  closeLabel: _propTypes.default.node,
  dismissable: _propTypes.default.bool,
  kind: _propTypes.default.oneOf(['alert', 'success', 'message', 'notification', 'floating']),
  label: _propTypes.default.string,
  onDismiss: _propTypes.default.func,
  show: _propTypes.default.bool,
  withIcon: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  isFloating: _propTypes.default.bool,
  textColor: _propTypes.default.string,
  isHighEmphasis: _propTypes.default.bool,
  position: _propTypes.default.oneOf(['top-left', 'top-center', 'top-right']),

  /** Enable disable portal functionality */
  enablePortal: _propTypes.default.bool,

  /** set z-index */
  zIndex: _propTypes.default.number
};
Snackbar.defaultProps = {
  closeLabel: 'Close alert',
  dismissable: false,
  withIcon: false,
  enablePortal: false,
  zIndex: _shared.theme.zIndex.snackbar
};